export function getCloudinaryUrl(cloudinaryImageUrl, cloudinaryParams = null, mediaType = "image") {
  const host = window.C.CLOUDINARY.host || "res.cloudinary.com";
  const bucket = window.C.CLOUDINARY.bucket || "tiz2";
  const base = `//${host}/${bucket}/${mediaType}/upload/`;

  if (cloudinaryImageUrl) {
    if (cloudinaryParams) {
      return `${base}${cloudinaryParams}${cloudinaryImageUrl}`;
    } else {
      return `${base}${cloudinaryImageUrl}`;
    }
  }
}
